export const PaymentMethods = Object.freeze({
    EFT: "eft",
    CASH: "cash",
    CHEQUE: "cheque",
    CREDIT_CARD: "credit-card",
});

export const PaymentTypes = Object.freeze({
    INITIAL_PRELIMINARY_FEE: "initial-preliminary-fee",
    FURTHER_PRELIMINARY_FEE: "further-preliminary-fee",
    BALANCE_DEPOSIT: "balance-deposit",
    BASE: "base",
    FRAME: "frame",
    LOCKUP: "lockup",
    FIX: "fix",
    COMPLETION: "completion",
    TENDER_FEE: "tender-fee",
    OTHER: "other",
});

export const ReceiptTypes = Object.freeze({
    MASTERPIECE: "Masterpiece",
    DEFAULT: "Default"
});

export const RefundStatuses = Object.freeze({
    SUBMITTED: "Submitted",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    CANCELLED: "Cancelled",
    PENDING: "Pending",
    VERIFIED: "Verified",
    FINALISED: "Finalised",
    FAILED: "Failed",
    VERIFY: "Verify"
});

export const RefundsTableColumns = Object.freeze({
    JOB: "Job",
    RECEIPT_NUMBER: "Receipt #",
    PAYMENT_METHOD: "Payment Method",
    LAND_ADDRESS: "Land Address",
    CONSULTANT: "Consultant",
    MANAGER: "Manager",
    REQUESTED_BY: "Requested By",
    STATUS: "Status",
    TO_BE_APPROVED_BY: "To Be Approved By",
    APPROVED_BY: "Approved By",
    APPROVED_DATE: "Approved Date",
    AMOUNT: "Amount",
    CANCELLATION_REASON: "Cancellation Reason",
    SALESFORCE_ACCOUNT: "Salesforce"
});

export const RefundsTableRequestDateFilter = Object.freeze({
    ALL: "All time",
    TODAY: "Today",
    YESTERDAY: "Yesterday",
    CUSTOM: "Choose date..."
});

export const RefundRequestGroups = Object.freeze({
    ALL: 'all',
    FOR_APPROVAL: 'for_approval',
    PENDING: 'pending',
    FOR_VERIFICATION: 'for_verification',
    VERIFIED: 'verified',
    REQUESTED: 'requested',
    PROCESSED: 'processed'
});

export const PaymentsAppSettingsType = Object.freeze({
    REFUND_FINALISED_EMAILS_RECIPIENT: 'refund-finalised-emails-recipient',
    REFUND_ERROR_EMAILS_RECIPIENT: 'refund-error-emails-recipient',
});

export const AppName = 'payments';

export const DEFAULT_TENDER_FEE_AMOUNT = 2000.00;